module.exports = {
  CATEGORIES: {
    METRIC: 'metric'
  },
  METRICS: {
    PIX_OPERATION_DURATION: {
      TYPE: {
        FULL_DICT_SEARCH: 'full_dict_search',
        PIX_KEY_OWNER_VERIFICATION: 'pix_key_owner_verification',
        PIX_KEY_REGISTER: 'pix_key_register',
        PIX_KEY_REMOVAL: 'pix_key_removal',
        CONFIRM_PIX_KEY_CLAIM: 'confirm_pix_key_claim',
        NOTIFY_USER_AFTER_CLAIM_ACK: 'notify_user_after_claim_ack'
      }
    }
  }
};
